import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://luke-ichpekov.github.io/portfolio/'
      className='link footer__link'
    >
      Created By Luke Ichpekov
    </a>
  </footer>
)

export default Footer
